import { render, staticRenderFns } from "./CurrentAccounts.vue?vue&type=template&id=674fda6b&scoped=true"
import script from "./CurrentAccounts.vue?vue&type=script&lang=js"
export * from "./CurrentAccounts.vue?vue&type=script&lang=js"
import style0 from "./CurrentAccounts.vue?vue&type=style&index=0&id=674fda6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674fda6b",
  null
  
)

export default component.exports